import { AdminService } from './../../../_services/admin.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Task } from 'src/app/_models/task';
import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-task-template-ability',
  templateUrl: './task-template-ability.component.html',
  styleUrls: ['./task-template-ability.component.css']
})
export class TaskTemplateAbilityComponent implements OnInit {

  @Input() taskTemplate = new Task()
  searchAbilityFormRequires:FormGroup
  searchAbilityFormProvides:FormGroup
  requiredAbilities=[]
  providedAbilities=[]
  abilitySearchListRequires=[]
  abilitySearchListProvides=[]
  constructor(private adminService:AdminService) { }

  ngOnInit(): void {
    this.requiredAbilities =this.taskTemplate.requiredAbilities
    this.providedAbilities = this.taskTemplate.providedAbilities
    this.searchAbilityFormRequires= new FormGroup({'searchInputRequires': new FormControl('')})
    this.searchAbilityFormProvides= new FormGroup({'searchInputProvides': new FormControl('')})
    this.onSearchFormRequiresChanges()
    this.onSearchFormProvidesChanges()
  }


  onSearchFormRequiresChanges(): void {
    if(this.searchAbilityFormRequires!=null){
      this.searchAbilityFormRequires.get('searchInputRequires').valueChanges.subscribe(val => {
        if(val.length>2){
          let data = new URLSearchParams();
          //data.set('id',this.taskTemplate.server_task_template_id.toString())
          data.set('q', val.toString());
          this.adminService.searchAbilityToAddToTaskTemplateRequires(data.toString(),this.taskTemplate.server_task_template_id).subscribe(
            dataData=>{
              this.abilitySearchListRequires=dataData

            }
          )
      }else{
        this.abilitySearchListRequires=[]
      }
    })
    }

}

onSearchFormProvidesChanges(): void {
  if(this.searchAbilityFormProvides!=null){
    this.searchAbilityFormProvides.get('searchInputProvides').valueChanges.subscribe(val => {
      if(val.length>2){
        let data = new URLSearchParams();

        data.set('q', val.toString());
        this.adminService.searchAbilityToAddToTaskTemplateProvides(data.toString(),this.taskTemplate.server_task_template_id).subscribe(
          dataData=>{
            this.abilitySearchListProvides=dataData

          }
        )
    }else{
      this.abilitySearchListProvides=[]
    }
  })
  }

}

addAbilityToTaskProvides(ability_id:number){
  let dd = this.formatDataAddAbilityToTemplate(ability_id)
  this.adminService.addAbilityToTaskProvides(dd,this.taskTemplate.server_task_template_id).subscribe(
    dataData=>{
      this.requiredAbilities=dataData['providedAbilities']
      this.removeAbilityFromProvidesSearchList(ability_id)
    }
  )
}

removeAbilityFromTaskProvides(ability_id:number){
  let dd = this.formatDataAddAbilityToTemplate(ability_id)
  this.adminService.removeAbilityFromTaskProvides(dd,this.taskTemplate.server_task_template_id).subscribe(
    dataData=>{
      this.requiredAbilities=dataData['providedAbilities']

    }
  )
}


addAbilityToTaskRequires(ability_id:number){
  let dd = this.formatDataAddAbilityToTemplate(ability_id)
  this.adminService.addAbilityToTaskRequires (dd,this.taskTemplate.server_task_template_id).subscribe(
    dataData=>{
      this.requiredAbilities=dataData['requiredAbilities']
      this.removeAbilityFromRequiresSearchList(ability_id)
    }
  )
}

removeAbilityFromTaskRequires(ability_id:number){
  let dd = this.formatDataAddAbilityToTemplate(ability_id)
  this.adminService.removeAbilityFromTaskRequires(dd,this.taskTemplate.server_task_template_id).subscribe(
    dataData=>{
      this.requiredAbilities=dataData['requiredAbilities']
    }
  )
}
formatDataAddAbilityToTemplate(ability_id:number){
  let data = new URLSearchParams();
  //data.set('id',this.taskTemplate.server_task_template_id.toString())
  data.set('ability_id', ability_id.toString());

  return data.toString()
}

removeAbilityFromProvidesSearchList(server_subtopic_id:number){
  let index=0
  for( let i =0; i < this.abilitySearchListProvides.length;i++){
    if(server_subtopic_id == this.abilitySearchListProvides[i].id){
      index=i
      this.abilitySearchListProvides.splice(index,1)
      break
  }
}
}

removeAbilityFromRequiresSearchList(server_subtopic_id:number){
  let index=0
  for( let i =0; i < this.abilitySearchListRequires.length;i++){
    if(server_subtopic_id == this.abilitySearchListRequires[i].id){
      index=i
      this.abilitySearchListRequires.splice(index,1)
      break
  }
}
}
}
